<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        absolute
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-subtitle class="pt-1 pb-1">
                    <span class="font-weight-bold">Información de proveedor</span>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text v-if="providerSelected && selectedDebt">
                    <template>
                        <v-row>
                            <v-col cols="5" class="pt-1 pb-1">
                                <span>Proveedor</span>
                            </v-col>
                            <v-col cols="7" class="pt-1 pb-1">
                                <span class="float-right subtitle-2">{{ providerSelected.name }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" class="pt-1 pb-1">
                                <span>Crédito Total</span>
                            </v-col>
                            <v-col cols="7" class="pt-1 pb-1">
                                <span class="float-right subtitle-2">{{ selectedDebt.amount | currency('S/') }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" class="pt-1 pb-1">
                                <span>Monto Pendiente</span>
                            </v-col>
                            <v-col cols="7" class="pt-1 pb-1">
                                <span class="float-right subtitle-2">{{ selectedDebt.amount_pending | currency('S/') }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" class="pt-1 pb-1">
                                <span>Fecha de vencimiento</span>
                            </v-col>
                            <v-col cols="7" class="pt-1 pb-1">
                                <span class="float-right subtitle-2">{{ selectedDebt.date_agreement | moment("DD/MM/YYYY") }}</span>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <v-card class="mt-3">
                <v-card-subtitle class="pt-1 pb-1">
                    <span class="font-weight-bold">Datos del pago</span>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="4">
                                <span>Monto a pagar</span>
                            </v-col>
                            <v-col cols="8">
                                <v-text-field
                                    ref="amount_payment"
                                    outlined
                                    solo
                                    dense
                                    hide-details
                                    prefix="S/"
                                    placeholder="0"
                                    type="number"
                                    v-model="form.amount_payment"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <span>Descripción</span>
                            </v-col>
                            <v-col cols="8">
                                <v-textarea
                                    outlined
                                    solo
                                    rows="5"
                                    v-model="form.description"
                                    hide-details
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <div class="mt-3" style="text-align: right;">    
                <template>
                    <v-row>
                        <v-col cols="6">
                            <v-btn @click="handleCancel" 
                                block 
                                height="45" 
                                dark 
                                color="red">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn dark 
                                color="green" 
                                block 
                                height="45"
                                :disabled="press_button"
                                @click="handleRegisterPayment">
                                Pagar
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </div>

        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'PayAccount',
    data() {
        return {
            titleForm: '',
            drawer: false,
            form: {
                amount_payment: null,
                description: null
            },
            press_button: false
        }
    },
    computed: {
        ...mapState('provider', [
            'providerSelected',
            'debtsProvider',
            'selectedDebt'
        ]),
    },
    methods: {
        ...mapActions('provider', [
            'getDebts',
            'runSetProviderSelected',
            'getDebtsByProvider',
            'replaceProviderDebtInDebtsList',
            'getTotalAmount'
        ]),
        showForm(title) {
            this.clearData()
            this.titleForm = title
            this.drawer = !this.drawer
        },
        clearData(){
            this.form.amount_payment = null,
            this.form.description = null
        },
        handleCancel() {
            this.drawer = false
        },
        handleRegisterPayment(){
            this.press_button = true;
            if (this.form.amount_payment === null || this.form.amount_payment <= 0) {
                this.press_button = false;
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE PAGO',
                    text: 'Debe ingresar el monto a pagar!'
                });
            } else if (parseFloat(this.form.amount_payment) > parseFloat(this.selectedDebt.amount_pending)) {
                this.press_button = false;
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE PAGO',
                    text: 'El monto a pagar debe ser menor o igual que el monto pendiente!'
                });
            } else{
                let payment = {
                    account_id: this.selectedDebt.id,
                    amount_payment: this.form.amount_payment,
                    description: this.form.description
                }
                apiService.amortizeProviderAccount(payment).then((response) => {
                    this.press_button = false;
                    let summaryDebtProvider = response.data.debtProvider[0]
                    this.getDebtsByProvider(this.selectedDebt.provider_id)
                    this.replaceProviderDebtInDebtsList(summaryDebtProvider)
                    this.getTotalAmount()
                    this.drawer = false
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE ACCIÓN REALIZADA',
                        text: 'La amortización se realizó de manera correcta!'
                    });
                });
            }
        }
    }
}
</script>

<style>

</style>